import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    refresh: 0,
    selectedFiles: [],
}

const fileManagerSlice = createSlice({
    initialState,
    name: "fileManager",
    reducers: {
        set_selected_files: (state, action) => {
            if (action.payload) {
                state.selectedFiles = [action.payload].filter((f, i, self) => self.map(ff => ff.id).indexOf(f.id) === i)
            }
        },
        reset_set_selected_files: (state, action) => {
            state.selectedFiles = initialState.selectedFiles
            return state
        },
        toggle_selected_file: (state, action) => {
            state.selectedFiles = state.selectedFiles.find(f => f.id === action.payload.id) ?
                state.selectedFiles.filter(f => f.id !== action.payload.id) :
                [...state.selectedFiles, action.payload]
        },
        refresh_dir_list: (state, action) => {
            state.refresh = state.refresh + 1
        },
    }
})

export default fileManagerSlice.reducer;

export const {
    refresh_dir_list,
    set_selected_files,
    toggle_selected_file,
    reset_set_selected_files,
} = fileManagerSlice.actions;
